export function HeroVisual() {
  return (
    <div className="relative w-full max-w-[520px] aspect-[4/3] sm:aspect-[16/13] mx-auto flex items-center justify-center select-none">
      {/* Soft diffused ambient light tint */}
      <div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-80 h-80 rounded-full bg-[#0D66E4]/6 blur-3xl pointer-events-none -z-10"
        aria-hidden="true"
      />

      {/* Main Software Interface Card */}
      <div className="relative w-[92%] sm:w-[86%] bg-white rounded-2xl sm:rounded-3xl p-6 sm:p-8 border border-[#E4E7EC] shadow-[0_20px_40px_-15px_rgba(16,24,40,0.06),0_1px_3px_rgba(16,24,40,0.04)]">
        
        {/* Header: Minimal Window Control and Title */}
        <div className="flex items-center justify-between pb-6 border-b border-[#F2F4F7]">
          <div className="flex items-center gap-2">
            <span className="w-2.5 h-2.5 rounded-full bg-[#E4E7EC]" />
            <span className="w-2.5 h-2.5 rounded-full bg-[#E4E7EC]" />
            <span className="w-2.5 h-2.5 rounded-full bg-[#E4E7EC]" />
          </div>
          <div className="text-xs font-medium text-[#98A2B3] tracking-wide">
            platform.safazatech.com
          </div>
        </div>

        {/* Modular Content Lines (Understated, Minimal, Clean) */}
        <div className="mt-8 space-y-5">
          <div className="space-y-2.5">
            <div className="h-4 bg-[#F2F4F7] rounded-md w-3/4" />
            <div className="h-3 bg-[#F2F4F7] rounded-md w-1/2" />
          </div>

          <div className="pt-4 grid grid-cols-2 gap-3">
            <div className="p-4 rounded-xl bg-[#F8FAFC] border border-[#E4E7EC]/60 space-y-2">
              <div className="h-2.5 bg-[#E2E8F0] rounded w-16" />
              <div className="h-5 bg-[#0D66E4]/10 rounded w-24" />
            </div>
            <div className="p-4 rounded-xl bg-[#F8FAFC] border border-[#E4E7EC]/60 space-y-2">
              <div className="h-2.5 bg-[#E2E8F0] rounded w-20" />
              <div className="h-5 bg-[#E2E8F0] rounded w-16" />
            </div>
          </div>
        </div>

        {/* Footer Area with Action Icon */}
        <div className="mt-8 pt-6 border-t border-[#F2F4F7] flex items-center justify-between">
          <div className="flex items-center gap-2 text-xs text-[#98A2B3]">
            <span>Modular Core</span>
            <span>&middot;</span>
            <span>API Gateway</span>
          </div>

          <div className="w-8 h-8 rounded-full bg-[#101828] text-white flex items-center justify-center shadow-xs">
            <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 19.5l15-15m0 0H8.25m11.25 0v11.25" />
            </svg>
          </div>
        </div>

      </div>

      {/* Subtle accent squircle matching the studio reference layout */}
      <div
        className="absolute -top-3 -right-2 sm:-top-4 sm:-right-3 w-14 h-14 bg-[#0D66E4] rounded-2xl shadow-[0_12px_24px_-6px_rgba(13,102,228,0.35)] flex items-center justify-center z-10"
        aria-hidden="true"
      >
        <div className="w-6 h-6 rounded-full border border-white/40 flex items-center justify-center">
          <div className="w-2 h-2 rounded-full bg-white" />
        </div>
      </div>
    </div>
  );
}
